import type { Translation } from '../types.ts';
import type en from '../en/pages.ts';

export default {
    shared: {
        noMatch: "Geen pagina's gevonden.",
        menusLink: "Menu's",
        viewOnSite: 'Bekijken op site',
        openInNewTab: '{url} openen in een nieuw tabblad',
        notLiveYet: 'Niet gepubliceerd: {url} is nog niet online',
    },
    list: {
        title: "Pagina's",
        search: 'Zoek op titel of slug',
        newPage: 'Nieuwe pagina',
        createOne: 'Maak er een aan',
        menusNote: "In welke menu's een pagina staat, de linktekst, de volgorde en de nesting beheer je in het scherm {menus}.",
    },
    row: {
        draft: '{locale}: concept',
        defaultLanguage: '{locale}: standaardtaal',
        defaultLanguageDraft: '{locale}: standaardtaal (concept)',
        translated: '{locale}: vertaald',
        translatedDraft: '{locale}: vertaald, nog niet gepubliceerd',
        notTranslated: '{locale}: niet vertaald (toont {fallback})',
    },
    picker: {
        label: 'Pagina',
        placeholder: "Pagina's zoeken…",
        loadFailed: "Pagina's laden is mislukt",
        home: '(startpagina) {title}',
        untitled: '(zonder titel)',
        draft: '(concept)',
    },
    edit: {
        newTitle: 'Nieuwe pagina',
        editInline: 'Inline bewerken',
        created: 'Pagina aangemaakt',
        confirmDelete: '"{title}" verwijderen? Hiermee verwijder je alle talen van deze pagina. Dit kan niet ongedaan worden gemaakt.',
        tabEdit: '{locale} bewerken',
        tabAdd: '{locale} toevoegen: velden die je niet vertaalt, blijven {fallback} tonen',
        tabDefault: 'standaard',
        tabDraft: 'concept',
        translateEmpty: 'Lege velden vertalen',
        translateEmptyTitle: 'Vul de lege vakken hieronder met een {locale}-vertaling van {fallback}. Er wordt pas iets opgeslagen als je op Opslaan klikt.',
        nothingToTranslate: 'Titel, URL en omschrijving hebben al {locale}-tekst',
        nothingLeft: 'Niets meer te vertalen',
        unaddable: 'Deze pagina is opgeslagen in {pageLocale}, dus {locale} (de standaardtaal van de site) kan er niet aan worden toegevoegd: de standaardtaal is altijd de pagina zelf.',
        translationAdded: '{locale} toegevoegd; onvertaalde velden blijven de standaardtaal tonen',
        translationRemoved: '{locale} verwijderd',
        confirmRemoveTranslation: 'De {locale}-versie verwijderen? Bezoekers zien daar dan weer {fallback}.',
        editingBanner: 'Je bewerkt {locale}. Wat je leeg laat, valt terug op {fallback}, ook de pagina-inhoud. Die vertaal je in de {link}.',
        inlineEditorLink: 'inline editor',
        slug: 'URL-slug',
        slugHintHome: 'Leeg = startpagina',
        slugHintTranslation: 'Het eigen URL-deel van deze taal',
        settings: 'Instellingen',
        locale: 'Taal',
        template: 'Template',
        templateShared: '{name} (gedeeld)',
        templateSharedNote: 'Template {template} geldt voor alle talen: wijzig het op het tabblad {locale}.',
        navigationNote: "Navigatie (in welke menu's deze pagina staat, de linktekst, de volgorde en de nesting onder een bovenliggend item) beheer je in het scherm {menus}.",
        publishLocale: '{locale} publiceren',
        publishOnSave: 'Publiceren bij opslaan',
        untilPublished: 'Zolang dit niet gepubliceerd is, zien bezoekers in {locale} de {fallback}-versie.',
        access: 'Toegang',
        thisLanguage: 'Deze taal',
        removeLocale: '{locale} verwijderen',
        removeLocaleHint: 'Verwijdert alleen de tekst van deze taal. De pagina blijft bestaan en bezoekers in {locale} zien weer {fallback}.',
        saveLocale: '{locale} opslaan',
    },
    translate: {
        translated: '{n} veld vertaald: controleer en sla op | {n} velden vertaald: controleer en sla op',
        failed: 'Kon {n} veld niet vertalen | Kon {n} velden niet vertalen',
        partial: '{filled} van {total} velden vertaald; {failed} moet je zelf invullen | {filled} van {total} velden vertaald; {failed} moet je zelf invullen',
    },
} satisfies Translation<typeof en>;
